// src/components/resources/tools/generators/AdMockup/CharCounter.tsx
'use client'

import { clsx } from 'clsx'

/**
 * Live character counter for the Google RSA fields — the accuracy moat. The
 * input itself caps length via `maxLength`, so this never shows an over-limit
 * count; it turns amber at the limit to signal "you're using the full asset"
 * (Google rewards using the full character budget). `tabular-nums` keeps the
 * count from shifting width as it changes.
 */
export function CharCounter({ value, max }: { value: string; max: number }): JSX.Element {
  const len = value.length
  const atLimit = len >= max
  return (
    <p className={clsx('mt-1 text-right text-[11px] tabular-nums', atLimit ? 'text-amber-600 dark:text-amber-400' : 'text-slate-400 dark:text-slate-500')}>
      {len}/{max}
    </p>
  )
}
